module.exports = __webpack_public_path__ + "img/logo.f777881a.png";